import {
  faAngleLeft,
  faAngleRight,
  faMagnifyingGlass,
  faPaperclip,
} from '@fortawesome/free-solid-svg-icons';
import unescape from 'unescape';
import uniq from 'lodash/uniq';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import PropTypes from 'prop-types';
import React from 'react';
import { connect } from 'react-redux';
import PhotoToolbar from './PhotoToolbar';
import SupportMessagePremium from './SupportMessagePremium/Loadable';
import ButtonPinterest from './ButtonPinterest';
import ButtonSocialShare from '../Gallery/ButtonSocialShare';
import ButtonCopyLink from '../PhotoDownload/ButtonCopyLink';
import withI18next from '~/../hocs/_withI18next';
import Config from '~/config';
import { nicePhoto } from '~/containers/PhotoPage/actions';
import themeVariables from '~/shared/themeVariables';

const mapDispatchToProps = (dispatch) => ({
  nicePhoto: (id) => dispatch(nicePhoto(id)),
});

@connect(null, mapDispatchToProps)
@withI18next()
class ImagesPreview extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      indexSelected: 1,
    };
  }

  onPaginationClick = (index) => {
    this.setState({ indexSelected: index });
  };

  onNext = () => {
    const { indexSelected } = this.state;
    const maxIndex = this.props.images.length - 1;
    if (indexSelected >= maxIndex) {
      return this.setState({ indexSelected: 1 });
    }
    this.setState({ indexSelected: indexSelected + 1 });
  };

  onPrevious = () => {
    const { indexSelected } = this.state;
    const maxIndex = this.props.images.length - 1;
    if (indexSelected <= 1) {
      return this.setState({ indexSelected: maxIndex });
    }
    this.setState({ indexSelected: indexSelected - 1 });
  };

  handleClickPinterest = () => {
    const { images } = this.props;
    const { indexSelected } = this.state;
    const { description } = this.props;
    let imageUrl = images[0].path;
    if (images.length > 1) {
      imageUrl = images[indexSelected].path;
    }
    /* eslint-disable */
    PinUtils.pinOne({
      url: window.location.href,
      media: imageUrl,
      description,
    });
  };

  render() {
    const { images } = this.props;
    const { indexSelected } = this.state;
    const {
      showSupportMessage,
      onToggleSupportMessage,
      isAuthenticated,
      profile,
      nicePhoto,
      t,
      lng,
      keywords,
      tags,
      photo,
    } = this.props;

    let supportMessage = null;
    let { width, height } = photo.assets[0];

    if (showSupportMessage) {
      // if (isAuthenticated && profile.role === roles.PREMIUM) {
      supportMessage = (
        <SupportMessagePremium
          onToggleSupportMessage={onToggleSupportMessage}
          onNice={nicePhoto}
        />
      );
      // } else {
      //   supportMessage = (
      //     <SupportMessageFreeMember onToggleSupportMessage={onToggleSupportMessage} />
      //   );
      // }
    }

    const assetFormats = uniq(photo.assets?.map((item) => item.format));
    let assetFormatsText = '';
    if (assetFormats.length > 1) {
      assetFormatsText = t('text_and_text', {
        text1: assetFormats.slice(0, assetFormats.length - 1).join(', '),
        text2: assetFormats[assetFormats.length - 1],
      });
    } else {
      assetFormatsText = assetFormats[0];
    }

    // Build alt text
    const altTextParts = [
      unescape(keywords) || t(Config.getPrefixContent('default_title')),
    ]
      .concat(tags.slice(0, 3).map((item) => item.name?.toLowerCase()))
      .concat(assetFormatsText);
    const altText = altTextParts.join(', ');

    // Build title text
    const titleTextParts = [
      unescape(keywords) || t(Config.getPrefixContent('default_title')),
    ].concat(assetFormatsText);
    const titleText = titleTextParts.join(', ');

    return (
      <figure className="images-preview">
        {images.length === 1 && (
          <>
            {/* remove overflow image preview then remove button-illust-image-action-mobile */}
            <div className="button-illust-image-action-mobile">
              <ButtonCopyLink isFromDownloadPage={true} />
              <div className="button-illust-image-social">
                <ButtonSocialShare photo={photo} isFromDownloadPage={true} />
              </div>
            </div>
            <div className="image-content">
              <picture className="img-responsive">
                <source
                  srcSet={images[0].thumbnail}
                  media="(max-width: 600px)"
                />
                <source srcSet={images[0].path} />
                <img
                  style={
                    !Config.isIllustAC()
                      ? width > height
                        ? { width: '100%' }
                        : { height: '100%' }
                      : {}
                  }
                  className="img-responsive"
                  src={images[0].thumbnail}
                  alt={altText}
                  title={titleText}
                  loading="eager"
                  decoding="sync"
                />
              </picture>
              {/* <img
                style={
                  !Config.isIllustAC()
                    ? width > height
                      ? { width: '100%' }
                      : { height: '100%' }
                    : {}
                }
                className="img-responsive"
                // src={images[0].path}
                // srcset={`${images[0].thumbnail} 1x, ${images[0].path} 2x `}
                // sizes={`(max-width: 599px) 300px,1000px`}
                srcset={`${images[0].thumbnail} 500w, ${images[0].path} 1000w `}
                sizes="(min-width: 599px) 100vw,100vw"
                alt={altText}
                title={titleText}
                loading="eager"
                decoding="sync"
              /> */}
              {/* <ACImage
                style={
                  !Config.isIllustAC()
                    ? width > height
                      ? { width: '100%' }
                      : { height: '100%' }
                    : {}
                }
                className="img-responsive"
                src={images[0].path}
                alt={altText}
                title={titleText}
                priority
                // loading="eager"
                // decoding="sync"
              /> */}
              {/* <div>xxx</div> */}
              {/* ButtonPinterest button is always neccessary although there is another Pinterest button in social share popup */}
              {!Config.isChina() && Config.isIllustAC() ? (
                <>
                  <div className="button-illust-image-action">
                    <ButtonCopyLink isFromDownloadPage={true} />
                    <div className="button-illust-image-social">
                      <ButtonSocialShare
                        photo={photo}
                        isFromDownloadPage={true}
                      />
                    </div>
                  </div>

                  <div
                    className="image-content-background"
                    style={{
                      backgroundImage: `url(${images[0].thumbnail})`,
                    }}
                  />
                </>
              ) : (
                <>
                  <div className="overlay-button-pinterest">
                    <ButtonPinterest onClick={this.handleClickPinterest} />
                  </div>
                  <PhotoToolbar lng={lng} />
                </>
              )}
              {supportMessage}
            </div>
          </>
        )}
        {images.length > 1 && (
          <div className="image-wrapper">
            <div className="image-pagination">
              <div className="text-center">
                <FontAwesomeIcon
                  style={{
                    width: 15,
                    transform: 'rotate(100deg)',
                  }}
                  icon={faPaperclip}
                />{' '}
                {images.length - 1} Files set
              </div>
              {images.map((item, index) => {
                if (index === 0) return null;
                return (
                  <div
                    role="button"
                    key={item.thumbnail}
                    className="image-pagination-item-wrapper"
                    onClick={() => {
                      this.onPaginationClick(index);
                    }}
                  >
                    <div className="image-pagination-item">
                      <img className="img-responsive" src={item.thumbnail} />
                    </div>
                    <div className="image-pagination-hover">
                      <FontAwesomeIcon
                        icon={faMagnifyingGlass}
                        style={{ width: '1em' }}
                      />
                    </div>
                    {index === indexSelected && (
                      <div className="current-thumbnail-arrow">
                        <FontAwesomeIcon
                          icon={faAngleRight}
                          style={{ width: '0.5em' }}
                        />
                      </div>
                    )}
                  </div>
                );
              })}
            </div>
            <div className="image-detail">
              <div className="left-icon" onClick={this.onPrevious}>
                <FontAwesomeIcon
                  icon={faAngleLeft}
                  style={{ width: '0.5em' }}
                />
              </div>
              <div className="image-container">
                {/* <picture className="img-responsive">
                  <source
                    srcset={`${images[indexSelected].thumbnail} 500w`}
                    media="(max-width: 599px)"
                  />
                  <source srcset={`${images[indexSelected].path} `} />
                  <img
                    style={
                      !Config.isIllustAC()
                        ? width > height
                          ? { width: '100%' }
                          : { height: '100%' }
                        : {}
                    }
                    className="img-responsive"
                    srcset={`${images[indexSelected].path} `}
                    alt={altText}
                    title={titleText}
                    loading="eager"
                    decoding="sync"
                  />
                </picture> */}
                <img
                  className="img-responsive"
                  src={images[indexSelected].path}
                />
              </div>
              <div className="right-icon" onClick={this.onNext}>
                <FontAwesomeIcon
                  icon={faAngleRight}
                  style={{ width: '0.5em' }}
                />
              </div>
            </div>
          </div>
        )}
        <style jsx>
          {`
            .main-image-wrapper {
              height: 100%;
            }
            .image-content {
              position: relative;
              height: ${Config.isIllustAC() ? '636px' : '586px'};
              display: flex;
              flex-direction: row;
              align-items: center;
              justify-content: center;
              overflow: hidden;
              border-radius: 4px;
              padding: ${Config.isIllustAC() ? '40px' : '0'};
            }
            // add min-width for improve cls
            .img-responsive {
              height: ${Config.isIllustAC() ? '636px' : '586px'};
              max-width: 100%;
              max-height: 100%;
              object-fit: contain;
              z-index: 1;
              box-shadow: 0 0 20px rgba(0, 0, 0, 0.3);
              min-width: 556px;
            }
          `}
        </style>
        <style jsx global>
          {`
            .images-preview:hover .photo-toolbar {
              opacity: 1;
            }
            .button-illust-image-action-mobile {
              display: none;
            }
            .image-content-background {
              filter: blur(60px);
              background-position: center;
              background-repeat: no-repeat;
              background-size: cover;
              position: absolute;
              width: 1648px;
              height: 1272px;
              z-index: 0;
            }
            .button-illust-image-action {
              position: absolute;
              top: 0;
              left: 0;
              display: flex;
              padding: 24px;
              width: 100%;
              height: 80px;
              background: linear-gradient(
                180deg,
                rgba(243, 244, 245, 0.9),
                rgba(243, 244, 245, 0.3)
              );
              z-index: 1;
            }
            .button-illust-image-social {
              width: 112px;
              height: 32px;
              display: flex;
              flex-direction: row;
              align-items: flex-start;
              padding: 0px;
              order: 1;
              flex-grow: 0;
              margin-left: 5px;
            }
            .images-preview {
              position: relative;
              background-color: ${themeVariables.colors.lightBackground};
            }
            .images-preview .overlay-support-message {
              position: absolute;
              top: 0;
              bottom: 0;
              left: 0;
              right: 0;
              background: rgba(0, 0, 0, 0.6);
              color: #fff;
              display: ${Config.isIllustAC() ? 'none' : 'flex'};
              flex-direction: column;
              align-items: center;
              justify-content: center;
            }
            .images-preview .overlay-support-message .icon-close {
              position: absolute;
              top: 14px;
              right: 14px;
              width: 20px;
              cursor: pointer;
            }
            .images-preview .overlay-support-message .icon-close:hover {
              opacity: 0.8;
            }
            .images-preview .overlay-support-message .text-0,
            .images-preview .overlay-support-message .text-1,
            .images-preview .overlay-support-message .text-2,
            .images-preview .overlay-support-message .text-3,
            .images-preview .overlay-support-message .text-4,
            .images-preview .overlay-support-message .text-5 {
              text-align: center;
            }
            .images-preview .overlay-support-message .text-1,
            .images-preview .overlay-support-message .text-0 {
              font-size: 30px;
              text-shadow: 0 1px 10px rgba(0, 0, 0, 0.7);
            }
            .images-preview .overlay-support-message .text-2,
            .images-preview .overlay-support-message .text-3,
            .images-preview .overlay-support-message .text-4,
            .images-preview .overlay-support-message .text-5 {
              font-size: 18px;
            }
            .images-preview .overlay-support-message .text-3 {
              margin-top: 28px;
            }
            .images-preview .overlay-support-message .text-4 {
              margin-top: 56px;
            }
            .images-preview .overlay-support-message .text-5 {
              margin-top: 28px;
            }
            .images-preview
              .overlay-support-message
              .text-5
              .button-premium-credit {
              padding: 10px;
            }
            .images-preview
              .overlay-support-message
              .text-5
              .button-premium-credit
              .icon-premium-after-download {
              margin-bottom: 5px;
            }
            @media (max-width: ${themeVariables.breakpoints.mobile
                .maxWidth}px) {
              .images-preview .image-content {
                position: relative;
                height: 300px;
                padding: ${Config.isIllustAC() ? '20px' : '0'};
                overflow: hidden;
              }
              .button-illust-image-action {
                top: -48px;
                justify-content: center;
                padding: 0;
                align-items: center;
                height: 48px;
                background: unset;
              }
              .images-preview {
                margin-top: 4px;
              }
              .images-preview .overlay-support-message .text-1 {
                font-size: 30px;
              }
              .images-preview .overlay-support-message .text-2,
              .images-preview .overlay-support-message .text-3 {
                font-size: 16px;
              }
              .button-illust-image-action-mobile {
                justify-content: center;
                padding: 0;
                align-items: center;
                height: 48px;
                background: unset;
                position: relative;
                display: ${Config.isIllustAC() ? 'flex' : 'none'};
                width: 100%;
                background: white;
              }
            }
            .images-preview .overlay-support-message .copy-attribution {
              display: flex;
              flex-direction: row;
              align-items: center;
              justify-content: space-between;
              padding: 7px;
              margin-top: 7px;
              background: #fff;
              border-radius: 2px;
              color: #1b2833;
            }
            .images-preview .overlay-support-message .copy-attribution a {
              color: #1b2833;
              text-decoration: underline;
            }
            .images-preview
              .overlay-support-message
              .copy-attribution
              .btn-copy {
              margin-left: 28px;
              width: 100px;
            }
            .images-preview
              .overlay-support-message
              .copy-attribution
              .icon-check {
              margin-right: 7px;
            }
            .images-preview .overlay-support-message .support-actions {
              width: 100%;
              display: flex;
              flex-direction: row;
              margin-top: 28px;
              justify-content: center;
            }
            .images-preview
              .overlay-support-message
              .support-actions
              .btn-support-action {
              max-width: 150px;
              width: 30%;
              margin: 0 7px;
            }
            .images-preview .overlay-button-pinterest {
              position: absolute;
              top: 5px;
              left: 5px;
              color: #fff;
              z-index: 2;
            }
            .images-preview .image-wrapper {
              display: flex;
              flex-wrap: wrap;
              background-color: #ffffff;
              padding: 15px 10px 15px 50px;
            }
            .images-preview .image-wrapper .image-pagination {
              width: 150px;
            }
            .images-preview
              .image-wrapper
              .image-pagination
              .image-pagination-item-wrapper {
              position: relative;
            }
            .images-preview
              .image-wrapper
              .image-pagination
              .image-pagination-item-wrapper:hover
              .image-pagination-hover {
              opacity: 1;
            }
            .images-preview
              .image-wrapper
              .image-pagination
              .image-pagination-hover {
              display: flex;
              opacity: 0;
              justify-content: center;
              align-items: center;
              flex-direction: column;
              position: absolute;
              -webkit-transition: opacity 0.5s;
              -moz-transition: opacity 0.5s;
              -ms-transition: opacity 0.5s;
              -o-transition: opacity 0.5s;
              transition: opacity 0.5s;
              top: 0;
              width: 100%;
              height: 100%;
              color: #fff;
              font-size: 35px;
              cursor: pointer;
              background-color: rgba(29, 29, 29, 0.5);
            }
            .images-preview
              .image-wrapper
              .image-pagination
              .image-pagination-item {
              margin: 10px 0;
              padding: 5px 10px;
              border: 1px solid rgba(0, 0, 0, 0.1);
              min-height: 180px;
              display: flex;
              flex-direction: column;
              justify-content: center;
              align-items: center;
            }
            .images-preview .image-wrapper .image-detail {
              padding: 10px;
              flex: 1;
              display: flex;
              align-items: center;
              justify-content: center;
            }
            .images-preview .image-wrapper .image-detail .left-icon,
            .images-preview .image-wrapper .image-detail .right-icon {
              width: 50px;
              font-size: 40px;
              margin: 0 15px;
              color: #ffa823;
              cursor: pointer;
              display: inline-block;
              user-select: none;
            }
            .images-preview .image-wrapper .image-detail .image-container {
              justify-content: center;
              height: 100%;
              display: flex;
              flex-direction: column;
            }
            .images-preview .icon-antivirus {
              position: absolute;
              top: 14px;
              right: 14px;
            }
          `}
        </style>
      </figure>
    );
  }
}

ImagesPreview.propTypes = {
  images: PropTypes.array,
};
ImagesPreview.defaultProps = {
  images: [
    {
      path:
        'https://data.photo-ac.com/data/thumbnails/c4/c4d3c0c4cbde624f79ce903e8d724964_w.jpeg',
      thumbnail:
        'https://data.photo-ac.com/data/thumbnails/c4/c4d3c0c4cbde624f79ce903e8d724964_w.jpeg',
    },
    {
      path:
        'https://data.photo-ac.com/data/thumbnails/ed/ed6214f7b43378dfae8cfff052604a24_w.jpeg',
      thumbnail:
        'https://data.photo-ac.com/data/thumbnails/ed/ed6214f7b43378dfae8cfff052604a24_w.jpeg',
    },
    {
      path:
        'https://data.ac-illust.com/data/thumbnails/3d/3d300dd9952e45997b8d130f5002a52a_t.jpeg',
      thumbnail:
        'https://data.ac-illust.com/data/thumbnails/3d/3d300dd9952e45997b8d130f5002a52a_t.jpeg',
    },
  ],
};
export default ImagesPreview;
